import React, { useEffect, useRef, useState } from 'react'

import PlayIcon from 'assets/icons/play.svg?react'
import s from './LazyLoadVideo.module.scss'

interface LazyLoadVideoProps {
  src: string
  poster?: string
  className?: string
  useIframe?: boolean
}

export const LazyLoadVideo = ({ src, poster, className, useIframe = false, ...props }: LazyLoadVideoProps) => {
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const [isVisible, setIsVisible] = useState(false)
  const [isPlaying, setIsPlaying] = useState(false)

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause()
      } else {
        videoRef.current.play()
      }
      setIsPlaying(!isPlaying)
    }
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.unobserve(entry.target)
        }
      },
      { threshold: 0.1 },
    )

    if (videoRef.current && !useIframe) {
      observer.observe(videoRef.current)
    }

    return () => {
      if (videoRef.current && !useIframe) {
        observer.unobserve(videoRef.current)
      }
    }
  }, [useIframe])

  if (useIframe) {
    return (
      <div className={`${s.videoWrapper} ${className || ''}`}>
        <iframe width="720" height="405" src={src} allow="clipboard-write; autoplay" allowFullScreen></iframe>
      </div>
    )
  }

  return (
    <div className={`${s.videoWrapper} ${!isPlaying ? s.paused : ''} ${className || ''}`}>
      <video
        ref={videoRef}
        controls={isPlaying}
        poster={poster}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        className={`${isVisible ? s.visible : s.hidden}`}
        {...props}
      >
        {isVisible && <source src={src} type="video/mp4" />}
      </video>
      {!isPlaying && (
        <button className={s.playButton} onClick={handlePlayPause}>
          <PlayIcon />
        </button>
      )}
    </div>
  )
}
